var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_645_18925",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_645_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 22.525C3.45 22.525 2.97917 22.3292 2.5875 21.9375C2.19583 21.5458 2 21.075 2 20.525V6.525C2 5.975 2.19583 5.50417 2.5875 5.1125C2.97917 4.72083 3.45 4.525 4 4.525H12.925L10.925 6.525H4V20.525H18V13.575L20 11.575V20.525C20 21.075 19.8042 21.5458 19.4125 21.9375C19.0208 22.3292 18.55 22.525 18 22.525H4ZM15.175 5.1L16.6 6.5L10 13.1V14.525H11.4L18.025 7.9L19.45 9.3L12.25 16.525H8V12.275L15.175 5.1ZM19.45 9.3L15.175 5.1L17.675 2.6C18.075 2.2 18.5542 2 19.1125 2C19.6708 2 20.1417 2.2 20.525 2.6L21.925 4.025C22.3083 4.40833 22.5 4.875 22.5 5.425C22.5 5.975 22.3083 6.44167 21.925 6.825L19.45 9.3Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.1bc0511b194d1308b73d69e93f78e2a0.svg";
export { ForwardRef as ReactComponent };